<template>
    <div>
        <HeaderBar/>
        <div class="auth-wrapper auth-v2 bg-white">
            <b-row class="auth-inner m-0">
                <div class="w-100 d-flex flex-column ">
                    <HeaderBar/>
                    <div class="mt-4  bg-white">
                        <!-- Basic Module -->
                        <div class="d-flex justify-content-center align-items-center mb-1 mt-3 ">
                            <div class="title" style="font-weight: 600;font-size: 24px;">Sanidad por lotes</div>
                        </div>
                        <div class="d-flex flex-wrap justify-content-center">
                            <b-row class="ml-1 mr-1">
                                <b-col
                                cols="6"
                                >
                                    <b-card class="text-center" @click="navigateTo('advance-healthvaccineIndex')">
                                        <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                        >
                                        <b-img width="60px" 
                                               src="@/assets/images/ganImage/icons/vaccines.png"
                                        />
                                        </b-avatar>
                                        <div class="truncate">
                                            <h2 class="mb-25 font-weight-bolder vsmall-font-card">
                                                Vacunación
                                            </h2>
                                        </div>
                                    </b-card>
                                </b-col>
                                <b-col
                                cols="6"
                                >
                                <!-- click="navigateTo('advance-loaddatadeworming') -->
                                    <b-card class="text-center" @click="navigateTo('advance-loadHeatlhIndex')">
                                        <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                        >
                                        <b-img width="60px" 
                                               src="@/assets/images/ganImage/icons/deworming.png"
                                        />
                                        </b-avatar>
                                        <div class="truncate">
                                            <h2 class="mb-25 font-weight-bolder vsmall-font-card">
                                                Desparasitación
                                            </h2>
                                        </div>
                                    </b-card>
                                </b-col>
                                <b-col
                                cols="6"
                                >
                                    <b-card class="text-center" @click="navigateTo('advance-diseasetreatmentIndex')">
                                        <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                        >
                                        <b-img width="60px" 
                                               src="@/assets/images/ganImage/icons/sickness.png"
                                        />
                                        </b-avatar>
                                        <div class="truncate">
                                            <h2 class="mb-25 font-weight-bolder vsmall-font-card">
                                                Enfermedad y Tratamientos
                                            </h2>
                                        </div>
                                    </b-card>
                                </b-col>
                                <b-col
                                cols="6"
                                >
                                    <b-card class="text-center" @click="navigateTo('advance-healthexameneIndex')">
                                        <b-avatar
                                        class="mb-1"
                                        variant="primary"
                                        size="100"
                                        >
                                        <b-img width="60px" 
                                               src="@/assets/images/ganImage/icons/exams.png"
                                        />
                                        </b-avatar>
                                        <div class="truncate">
                                            <h2 class="mb-25 font-weight-bolder vsmall-font-card">
                                                Exámenes
                                            </h2>
                                        </div>
                                    </b-card>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                </div>
                <ControlMenu />
            </b-row>
        </div>
    </div>
</template>

<script>
import { BRow, BCol, BLink, BImg, BForm, BButton, BCard, BAvatar  } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'

export default {

    components: {
        BRow,
        BCol,
        BLink,
        BImg,
        BForm,
        BButton,
        BCard, 
        BAvatar,
        ControlMenu,
        HeaderBar
    },
    data() {
        return {

        }
    },
    methods:{
        navigateTo(routeName){
            this.$router.push({name:routeName});
        }
    }
}

</script>

<style lang="scss">
.title1{
    position: absolute;
    font-family: 'Montserrat';
    font-style: normal;
    top:2%;
    font-weight: 600;
    font-size: 24px;
    color: #5E5873;
}
.imageBunch {
    position: absolute;
    top: 15%;
}

.warningImage {
    position: absolute;
    width: 162px;
    top:65%;
}
.vsmall-font-card{
    font-size:13px !important;
}
@import '@core/scss/vue/pages/page-auth.scss';
</style>